<div id="timeDatePopover" class="time_date_popover">
    <form [formGroup]="datetimePickerFrm">
        <div id="datePickerForm" [ngClass]="!divideDate ? 'date-picker-form' : ''">
            <div id="datePickerRow" [ngClass]="divideDate ? 'divide_picker_row' : hideCalendar ? 'picker_row_hideCalendar' : 'picker_row'" >
                <!--Date Picker-->
                <div id="datePickerField" *ngIf="!hideCalendar" class="date-field "  [ngClass]="divideDate ? 'item1' : ''">
                    <div id="datePickerGroup" class="input-group">
                        <input class="form-control date-text-fld" placeholder="{{searchPlaceholderText}}" name="dp"
                            [(ngModel)]="dateModel" (dateSelect)="checkDate($event)" ngbDatepicker #d="ngbDatepicker"
                            id="publishedTimeStamp" formControlName="publishedTimeStamp" container="body"
                            [minDate]="minDate" [readonly]="true">
                        <div id="datePickerCalendarBtn" class="input-group-append">
                            <button class="btn calendar" (click)="d.toggle()" type="button"></button>
                        </div>
                    </div>
                </div>

                <!-- time-picker for divivide alignment -->
                <div id="timePickerDivide" *ngIf="divideDate" [ngClass]="divideDate ? 'item2' : ''">
                    <div id="timePickerDivideField" class="time_field">
                        <div id="ngbTimePickerDivide">
                            <ngb-timepicker  size="small" formControlName="time" name="time"></ngb-timepicker>
                        </div>
                    </div>
                </div>

                <!-- time-picker for inline alignment -->
                <div id="timePickerInline" *ngIf="!divideDate" class="time_field">
                        <div id="ngbTimePickerInline">
                            <ngb-timepicker size="small" formControlName="time" name="time"></ngb-timepicker>
                        </div>
                </div>
                
                <div id="timePickerInlineField" class="time_zone_field" [ngClass]="{'item3' : divideDate, 'widthTZ':isProfilePage}" [hidden]="hideCalendar">
                    <!-- <div ngbDropdown class="btn-group time-zone-div" display="dynamic" placement="{{placement}}">
                        <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                            id="timeZoneBtn" ngbTooltip="{{timeZoneVal}}">
                            <span class="time-zone-span">{{timeZoneVal}}</span>
                        </button>
                        <div ngbDropdownMenu>
                            <ng-container *ngFor="let timeZoneValue of timeZone">
                                <ng-container *ngIf="timeZoneVal!=timeZoneValue.timeZoneValue">
                                    <button class="timeZone-list" ngbDropdownItem (click)="getSelectedTimeZone(timeZoneValue.timeZoneValue)">{{ timeZoneValue.timeZoneValue }}</button>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div> -->
                    <div id="timePickerInlineDropDown" class="time-zone-div" [ngClass]="isProfilePage ? '' : hideCalendar? 'dropDownSize': 'dropDownClass'">
                        <ng-select [ngClass]="isAttractLoop ? 'no_dropdown_width' : 'timezone-drop'" [items]="timeZone" placeholder="{{timeZoneText}}" ngbTooltip="{{timeZoneVal}}"
                            bindLabel="timeZoneValue" [clearable]="true" 
                            [(ngModel)]="valueForTimeZone" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" 
                            (change)="getSelectedTimeZone($event)">
                        </ng-select>
                        <div id="valueTimeZone" *ngIf="!valueForTimeZone" class="search-icon"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>